import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import useFilters from "../../customHooks/useFilters";
import Header from "./Header";
import Filter from "../../components/filters/Filter";
import UserCard from "./UserCard";
import { Context } from "../..";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import { observer } from "mobx-react-lite";
import Timofey from "../../assets/images/Timofey_avatar.png";
import { IUsers } from "../../models/IUsers";

const Users: FC = () => {
  const { users, store, roles } = useContext(Context);
  const statusFilter = useFilters();
  const [adminPermissionData, setAdminPermissionData] = useState<any>()
  const [usersList, setUsersList] = useState<IUsers[]>([]);

    useEffect(() => {
      users.setUsersFilter(statusFilter.checkedValues);
      users
        .loadList()
        .then((res: any) => {
          setUsersList(res);
        })
        .catch(console.log);
    }, [statusFilter.checkedValues]);

  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = users.UsersList.filter((item: any) => {
        const { email, name, phone, _id } = item;
        return Object.values({ email, name, phone, _id })
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setUsersList(filteredData);
    } else {
      setUsersList(users.UsersList);
    }
  };

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "users")
    setAdminPermissionData(userData)
  };

  useEffect(() => {
    loadNewData()
  }, [])

  return (
    <div className="users">
      <Header searchItems={searchItems} />
      <div className="body">
        {usersList.length > 0 && !users.loadingUsersBool ? (
          usersList.map((user, index) => (
            <UserCard data={user} index={index + 1} key={user._id} actionData={adminPermissionData}/>
          ))
        ) : usersList.length === 0 && !users.loadingUsersBool ? (
          <Emptiness icon={Timofey} content="There are no users yet" />
        ) : (
          <Spinner />
        )}
      </div>
      <div className="filters">
        <Filter
          title="Status"
          list={[
            { label: "Active", value: "show", default: true },
            { label: "Inactive", value: "hidden" },
          ]}
          onSelect={statusFilter.handleSelect}
        />
      </div>
    </div>
  );
};

export default observer(Users);
